import React, { useState } from "react";
import Button, { ButtonSize } from "shared/Button";
import styles from "./UnarchiveAppModal.module.css";

export default function UnarchiveAppModal({ apps, onClose, onSubmit }) {
  const [unarchivingAppId, setUnarchivingAppId] = useState(null);
  const [error, setError] = useState("");

  const handleUnarchive = async (app) => {
    setUnarchivingAppId(app.applicationTypeId);
    setError("");

    try {
      const result = await onSubmit(app.applicationTypeId);
      if (!result?.success) {
        setError(result?.message || "Unable to unarchive this application.");
        setUnarchivingAppId(null);
        return;
      }

      onClose();
    } catch (submitError) {
      setError(submitError.message || "Unable to unarchive this application.");
      setUnarchivingAppId(null);
    }
  };

  return (
    <div className={styles.modalBackground}>
      <section
        className={styles.modalContainer}
        role="dialog"
        aria-modal="true"
        aria-labelledby="unarchive-app-title"
      >
        <header className={styles.header}>
          <h2 id="unarchive-app-title">Unarchive App</h2>
          <Button size={ButtonSize.small} onClick={onClose}>
            Close
          </Button>
        </header>

        {error && (
          <p className={styles.error} role="alert">
            {error}
          </p>
        )}

        {apps.length === 0 ? (
          <p className={styles.empty}>There are no archived apps.</p>
        ) : (
          <ul className={styles.appList}>
            {apps.map((app) => (
              <li className={styles.appRow} key={app.applicationTypeId}>
                <span className={styles.appName}>{app.name}</span>
                <Button
                  size={ButtonSize.small}
                  disabled={unarchivingAppId != null}
                  onClick={() => handleUnarchive(app)}
                >
                  {unarchivingAppId === app.applicationTypeId
                    ? "Unarchiving..."
                    : "Unarchive"}
                </Button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
